<template>
  <v-flex>
    <v-layout row wrap>
      <v-flex xs12>
        <h2 class="primary--text pb-2">Security</h2>
        <p>Configure account-level session security and single sign-on.</p>
      </v-flex>

      <v-flex xs12 sm6 :class="{ 'pr-0 pb-4 mt-3': $vuetify.breakpoint.smAndDown, 'mt-3 pr-4 pb-0': $vuetify.breakpoint.mdAndUp }">
        <v-text-field
          v-model.number="refreshTokenExpiryHoursInput"
          type="number"
          min="1"
          box
          label="User Session Timeout (hours)"
          hint="Controls how long users can stay signed in before reauthentication is required. Default is 24 hours."
          persistent-hint
          @change="emitRefreshTokenExpiryChange"
        ></v-text-field>
      </v-flex>

      <AccountConfigSso :account="account" v-on:update-account-data="forwardUpdate" />
    </v-layout>
  </v-flex>
</template>

<script>
import AccountConfigSso from "@/components/accounts/account-config/AccountConfigSso.vue"

export default {
  name: "account-security",
  components: { AccountConfigSso },
  props: ["account"],
  data() {
    return {
      refreshTokenExpiryHoursInput: 24,
    }
  },
  watch: {
    account: {
      handler(newAccount) {
        if (newAccount && newAccount.refreshTokenExpiryHours) {
          this.refreshTokenExpiryHoursInput = newAccount.refreshTokenExpiryHours
        }
      },
      immediate: true,
    },
  },
  methods: {
    emitRefreshTokenExpiryChange() {
      const value = parseInt(this.refreshTokenExpiryHoursInput, 10)
      if (!Number.isInteger(value) || value <= 0) {
        return
      }
      this.$emit("update-account-data", { key: "changedRefreshTokenExpiryHours", value })
    },
    forwardUpdate(data) {
      this.$emit("update-account-data", data)
    },
  },
}
</script>
